export type DifficultyLevel = "beginner" | "intermediate" | "advanced"

export const DIFFICULTY_LABEL: Record<DifficultyLevel, string> = {
  beginner: "Básico",
  intermediate: "Intermedio",
  advanced: "Avanzado",
}

export const DIFFICULTY_BADGE_CLASS: Record<DifficultyLevel, string> = {
  beginner: "border-emerald-500/30 bg-emerald-500/10 text-emerald-400",
  intermediate: "border-amber-500/30 bg-amber-500/10 text-amber-400",
  advanced: "border-rose-500/30 bg-rose-500/10 text-rose-400",
}

export function isDifficultyLevel(value?: string | null): value is DifficultyLevel {
  return value === "beginner" || value === "intermediate" || value === "advanced"
}

export function getDifficultyLabel(value?: string | null): string | null {
  return isDifficultyLevel(value) ? DIFFICULTY_LABEL[value] : null
}

export function getDifficultyBadgeClass(value?: string | null): string {
  return isDifficultyLevel(value)
    ? DIFFICULTY_BADGE_CLASS[value]
    : "border-border/60 bg-white/5 text-muted-foreground"
}
